export default __webpack_public_path__ + "static/7-cariboo-label-35779e0dc4999712e2739deaedd1703b.svg";